module.exports = __webpack_public_path__ + "img/becomeinst.d2f99f4c.svg";